import { message } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const CopyComponent = (props: any) => {
  const { text, content, classNameBtn, classNameMessage } = props;
  const { t } = useTranslation();

  const handleCopy = (e: any, txt: string) => {
    e.preventDefault();
    navigator.clipboard.writeText(txt);
    message.success({
      content: t("copied"),
      className: classNameMessage,
      duration: 1,
    });
  };

  return (
    <a
      className={classNameBtn}
      title="Copy"
      onClick={(e: any) => handleCopy(e, text)}>
      {content}
    </a>
  );
};

export default CopyComponent;
